import script from "./MySchoolInvestSend.vue?vue&type=script&setup=true&lang=js"
export * from "./MySchoolInvestSend.vue?vue&type=script&setup=true&lang=js"

import "./MySchoolInvestSend.vue?vue&type=style&index=0&id=8179fcb0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8179fcb0"]])

export default __exports__